/* bolero-swatch-hover.js — product-card swatch hover preview.

   ECOM-59 (2026-09-12): this IIFE used to be emitted inline by
   snippets/product-card.liquid, i.e. once PER CARD — 16 copies on a PDP and
   48 on a collection page, of which all but the first returned immediately on
   the window.__swatchHoverReady guard. Both listeners are delegated from
   `document`, so exactly one copy is needed per page. Moved here so it is
   fetched once, cached, and kept out of the HTML.

   Loaded once from layout/theme.liquid (defer). Behaviour is unchanged.
*/
(function () {
  if (window.__swatchHoverReady) return;
  window.__swatchHoverReady = true;

  function swapWidth(src, width) {
    try {
      var u = new URL(src);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  /* mouseover bubbles, so we can delegate from document */
  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('.product-card__variant-swatches .thumbnail-swatch');
    if (!swatch) return;
    var card = swatch.closest('product-card');
    if (!card) return;
    var preview = card.querySelector('.product-card__image--swatch-preview');
    if (!preview) return;
    var swatchImg = swatch.querySelector('img');
    if (!swatchImg) return;
    var newSrc = swapWidth(swatchImg.src, 800);
    if (preview.getAttribute('data-hover-src') !== newSrc) {
      preview.setAttribute('data-hover-src', newSrc);
      preview.src = newSrc;
    }
    preview.classList.add('is-active');
  });

  /* Hide when cursor leaves the swatches fieldset entirely.
     Using mouseout (not mouseleave) so it bubbles and can be delegated.
     relatedTarget check ensures we ignore moves between child swatches. */
  document.addEventListener('mouseout', function (e) {
    var swatches = e.target.closest('.product-card__variant-swatches');
    if (!swatches) return;
    if (swatches.contains(e.relatedTarget)) return;
    var card = swatches.closest('product-card');
    if (!card) return;
    var preview = card.querySelector('.product-card__image--swatch-preview');
    if (!preview) return;
    preview.classList.remove('is-active');
  });
})();
